import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import InlineSVG from 'svg-inline-react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import _ from 'lodash';

import FileIcon from '../FileIcon/FileIcon';

import { humanizeFilesize } from '../../models/File';
import { renderDateInGriddleCell } from '../../helpers/renderDateInGriddleCell';

import DownloadIcon from '../../assets/ic-file-download.svg';

import classes from './FileTable.scss';

const renderExtension = data => <FileIcon extension={data.value} />;

const renderCell = data => {
  const values = _.split(data.value, ':-:');
  const name = values[0];
  // const id = values[1];
  const link = values[2];
  const fileSize = humanizeFilesize(parseInt(values[3], 10));

  return (
    <span>
      <Link to={link} target="_blank" className={classes.link}>
        {name}
      </Link>
      <span className={classes.fileSize}>{fileSize}</span>
    </span>
  );
};

const renderDateCell = data =>
  renderDateInGriddleCell(data, 'DD.MM.YYYY [ · ] HH:mm');
const components = {
  NoResults: () => (
    <div>
      <p className="text-center">
        <small>Keine Dateien eingetragen.</small>
      </p>
    </div>
  ),
};
const prepareData = dataArray => {
  const newData = [];
  dataArray.forEach(data => {
    const filename = `${data.filename_download}:-:${data.id}:-:${data.download}:-:${data.filesize}`;
    const options = `${data.id}:-:${data.download}`; // create new object that will be handled by griddle

    if (typeof data.deleted_at === 'undefined' || data.deleted_at === null) {
      newData.push({
        id: data.id,
        extension: data.extension,
        filename,
        createdDate: data.created_at,
        options,
      });
    }
  });
  return newData;
};
class FileTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }
  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };
  renderOptionsCell = data => {
    const values = _.split(data.value, ':-:');
    const id = values[0];
    const link = values[1];
    return (
      <span>
        <Link to={link} target="_blank" className={classes.iconDownload}>
          <InlineSVG src={DownloadIcon} />
        </Link>
        <IconMenu
          iconButtonElement={
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          }
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <MenuItem
            primaryText="Löschen"
            leftIcon={
              <DeleteIcon className="svg-icon-primary svg-icon-warning" />
            }
            onTouchTap={() => {
              this.setState({
                alert: (
                  <Dialog
                    actions={[
                      <FlatButton
                        label="Abbrechen"
                        primary
                        onTouchTap={this.handleAlertClose}
                      />,
                      <FlatButton
                        label="Löschen"
                        primary
                        onTouchTap={() => {
                          this.handleAlertClose();
                          this.props.deleteFile(id);
                        }}
                      />,
                    ]}
                    modal={false}
                    open
                    onRequestClose={this.handleAlertClose}
                  >
                    Datei wirklich löschen?
                  </Dialog>
                ),
              });
            }}
          />
        </IconMenu>
      </span>
    );
  };

  render() {
    const props = this.props;
    return (
      <div>
        <Griddle
          data={prepareData(props.files)}
          plugins={[plugins.LocalPlugin]}
          components={components}
          pageProperties={{
            pageSize: 20,
          }}
        >
          <RowDefinition keyColumn="id">
            <ColumnDefinition
              id="id"
              title="ID"
              cssClassName="text-right"
              visible={false}
            />
            <ColumnDefinition
              id="extension"
              title=" "
              sortable={false}
              customComponent={renderExtension}
            />
            <ColumnDefinition
              id="filename"
              title="Name"
              customComponent={renderCell}
            />
            <ColumnDefinition
              id="createdDate"
              title="Hochgeladen am"
              customComponent={renderDateCell}
            />
            <ColumnDefinition
              id="options"
              title=" "
              sortable={false}
              cssClassName={classes.options}
              customComponent={this.renderOptionsCell}
            />
          </RowDefinition>
        </Griddle>
        {this.state.alert}

        <div className={classes.upload}>
          Sie können Dateien in dieses Fenster ziehen, um sie hinzuzufügen.
        </div>
      </div>
    );
  }
}
FileTable.propTypes = {
  files: PropTypes.array.isRequired, // eslint-disable-line react/no-unused-prop-types
  deleteFile: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
};

export default FileTable;



// WEBPACK FOOTER //
// ./src/components/FileTable/FileTable.js